
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","d":"M8.5 15.5a7 7 0 0 0 6.69-4.937A7 7 0 0 0 15.5 8.5a7.003 7.003 0 0 0-7-7m0 14a7 7 0 0 1-6.69-4.937A7 7 0 0 1 1.5 8.5a7.003 7.003 0 0 1 7-7m0 14c1.785 0 3.233-3.134 3.233-7s-1.448-7-3.233-7m0 14c-1.785 0-3.233-3.134-3.233-7s1.448-7 3.233-7m6.632 5H1.75m13.5 4H1.868"}})])
          )
        }
      }
    